import React, { useState, useEffect, useRef } from 'react';

import CardRowCenter from 'components/Card/CardRowCenter.js';
import CardRowLeft from 'components/Card/CardRowLeft.js';
import CardRowRight from 'components/Card/CardRowRight.js';
import ExpandedInfo from 'components/Card/ExpandedInfo.js';
import ExternalAppButton from 'components/Card/ExternalAppButton.js';
import ReactGA from 'react-ga4';
import RouteAlert from 'components/Card/RouteAlert.js';
import Tappable from 'components/common/Tappable';
import MappedInMap from 'components/Card/Map/MappedInMap';
import { useShortCode } from '../../context/loaderContext';
import { useQRCodeModal } from '../../context/qrCodeModalContext';

function CardRow(props) {
    const [isExpanded, setIsExpanded] = useState(false);
    const cardWasOpened = useRef(false);

    const shortCode = useShortCode();
    const { showQRCodeModal } = useQRCodeModal();

    useEffect(() => {
        if (props.opened && !isExpanded) {
            setIsExpanded(true);
        }
    }, [props.opened, isExpanded]);

    useEffect(() => {
        // Additionally do a one-time post-action to de-expand on card close
        if (props.opened) {
            cardWasOpened.current = true;
        } else if (!props.opened) {
            if (cardWasOpened.current) {
                setIsExpanded(false);
            }
            cardWasOpened.current = false;
        }
    }, [props.opened]);

    function tapToggleCardRowExpand() {
        ReactGA.event("Row Clicked", {
            category: "Row Clicked",
            action: `${isExpanded ? 'Row Expanded' : 'Row Compressed'}`,
            agencyId: props.card.agencyId,
            stopName: props.card.stopName,
            expanded: !isExpanded
        });
        setIsExpanded(!isExpanded);

        if (shortCode === '9BHBT') {
            showQRCodeModal(`https://web.mappedin.com/redding-area-bus-authority/redding-downtown-terminal.html#/embed?from=9BHBT&to=${props.rowData?.shortRoute}`, props.rowData?.shortRoute, props.rowData?.destination);
        } else if (shortCode === 'JRUH8') {
            props.openMappedIn(props.rowData?.shortRoute);
        }
    }

    function getExternalAppButton() {
        const {
            card,
            rowData,
        } = props;
        const {
            agency,
            agencies,
        } = card;

        const {
            externalUrl,
            agencyId,
        } = rowData;

        const rowAgency = agencies ? agencies[agencyId] : agency;

        let component = null;

        if (rowAgency) {
            if (externalUrl) { // API has given us the url already
                component = <ExternalAppButton linkType="GET_VEHICLE" universalLink={externalUrl} agency={rowAgency} />;
            } else if (rowAgency?.app?.appName) { // We will sniff it out of the app info
                component = <ExternalAppButton linkType="GET_VEHICLE" agency={rowAgency} />;
            }
        }
        return component;
    }

    return (
        <div role="row" className="CardRow">
            {
                props.card.category === 'masstransit' && props.interactive !== 'false'
                ? <Tappable className="TapArea" pressDelay={1500} onTap={tapToggleCardRowExpand} stopPropagation />
                : null
            }

            {getExternalAppButton()}

            <div className="RouteInfo">
                <CardRowLeft {...props} />
                <CardRowCenter {...props} />
                <CardRowRight {...props} />
            </div>
            <ExpandedInfo {...{...props, isExpanded}} />
            <RouteAlert {...{...props, isExpanded}} />
        </div>
    );
}

export default CardRow;
